module.exports = __webpack_public_path__ + "img/02智慧矿山.d250c30b.jpg";